export class ReportModel{
    PartnerIndex: number = 0;
    PortfolioIDs: Array<number> = [];
    StartDate: Date =  new Date(new Date().getFullYear() - 1, 11, 31);
    EndDate: Date = new Date();
    CurrencyIndex: number = 0;
    TotalLiquidity:number = 0;
    TotalClaimsAndLiabilities:number = 0;
    TotalSecurities:number = 0;
    TotalInterest:number = 0;
    TotalAsset:number = 0;
    TotalPurchaseValue:number = 0;
    ProfitCurrency:number = 0;
    TotalProfitPrice:number = 0;
    TotalProfit:number = 0;
    TWPerformance:number = 0;
    MWPerformance:number = 0;
    SimplePerformance:number = 0;
    TotalInOutAmount:number = 0;
    Performance:number = 0;
    StartingAsset:number = 0;
    PDFReportBase64: string = "";
    ReferentCurrency: string = "CHF";
    ReportingCurrency: string = "CHF";
    WebAccessEnabled: boolean = true;
}

 


// WEBPACK FOOTER //
// ./app/insa-models/report.model.ts